/**
 * 专注模式
 */
import { atom, useAtomValue } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

import posthog from '@leyan/lytics';

const focusModeState = atom<boolean>(false);

export const useFocusMode = () => useAtomValue(focusModeState);
export const useSetFocusMode = () => {
  return useAtomCallback(
    useCallback((_, set, newValue: boolean) => {
      set(focusModeState, newValue);
      posthog.capture('$focusModeToggle', {
        value: newValue,
      });
    }, []),
  );
};
